<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Header con Filtros y Acciones -->
          <BrandListTableHeader
            :title="$t('key_brandList_table_title')"
            :description="$t('key_brandList_table_description')"
            :enable-reload="true"
            :enable-search="true"
            :selected-ids="selectedIds"
            :list-filters="filters"
            @add-brand="addBrand"
            @search-change="searchChange"
            @reload-page="reloadPage"
            @import-status-filter-change="importStatusFilterChange"
            @clear-all-filters="clearAllFilters">  <!-- TODO: Pendiente de calibrar los componentes por las preferencias del usuario --> 
          </BrandListTableHeader>
          
          <!-- Tabla con los Datos -->
          <GenericTableV2
            ref="genericTable"
            :items="brandsData?.items"
            :pagination="pagination"
            :headers="headers"
            :selected-ids="selectedIds"
            :is-loading="isLoading"
            @changed-header="onChangeHeader"
            @changed-page="paginationPageChange"
            @changed-row="paginationRowChange"
            @changed-selection="changedSelection">
            <template #row="{item}">
              <td style="width: 30rem" class="text-xs font-weight-bolder">
                <i class="fa fa-download text-primary" aria-hidden="true"></i>
                <a v-if="item.filename" class="ms-2 cursor-pointer font-weight-bold text-primary" :title="$t('key_download_file') + ' ' + item.filename" @click="OnDownloadBatch(batch)">
                  {{ item.filename }}
                </a>
              </td>
              
              
              
              
              
              <!--<td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ item.type.replace("_"," ") }}
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ item.entity_type }}
              </td>
              <td style="width: 10rem" class="font-weight-bolder">
                <span v-if="batch.status != 'ERROR'" class="badge badge-imported badge-sm">{{ $t('key_status_success') }}</span>
                <span v-else class="badge badge-error badge-sm" :title="batch.error">{{ $t('key_status_error') }}</span>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ $dateUtils.toDDMMYYYYHH(item.created_at) }}
              </td> -->
              <!--<td style="width: 40%" class="text-xs cursor-pointer font-weight-bold mb-0 picko-link">
                <div class="d-flex">
                  <div class="my-auto form-check">
                    <input :id="item._id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item._id)" @change="changedSelection(item._id)" >
                  </div>
                  <h6 class="my-auto ms-3 picko">
                    <a class="font-weight-bold columns text-primary" href="#" @click.prevent="openWarehouse(item.name)">
                      {{ item.name }}
                    </a>
                  </h6>
                </div>
              </td>
              <td class="font-weight-bold text-success">
                <span class="my-2 text-xs columns">{{$numberFormat.toDecimalFormat(item.available)}}</span>
              </td>
              <td class="font-weight-bold text-warning">
                <span class="my-2 text-xs columns">{{$numberFormat.toDecimalFormat(item.booked)}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{$dateUtils.toDDMMYYYYHH(item.updated_at)}}</span>
              </td>-->
            </template>
          </GenericTableV2>
        </div>
      </div>
    </div>
  </div>





















































  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!batchLoads"
            ref="genericTable"
            :items="batchLoads.data.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <!-- <template #row="batch">
              <td style="width: 30rem" class="text-xs font-weight-bolder">
                <i class="fa fa-download text-primary" aria-hidden="true"></i>
                <a v-if="batch.filename" class="ms-2 cursor-pointer font-weight-bold text-primary" :title="$t('key_download')" @click="OnDownloadBatch(batch)">
                  {{ batch.filename }}
                </a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ batch.type.replace("_"," ") }}
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ batch.entity_type }}
              </td>
              <td style="width: 10rem" class="font-weight-bolder">
                <span v-if="batch.status != 'ERROR'" class="badge badge-imported badge-sm">{{ $t('key_status_success') }}</span>
                <span v-else class="badge badge-error badge-sm" :title="batch.error">{{ $t('key_status_error') }}</span>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                {{ $dateUtils.toDDMMYYYYHH(batch.created_at) }}
              </td>
            </template> -->
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      
      
      
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import BrandListTableHeader from "./../../components/BrandListTableHeader.vue";
  import GenericTableV2 from "./../../../../generic_components/GenericTableHeaderV2.vue";

  export default {
    name: "BrandList",
    components: {
      GenericTableV2,
      BrandListTableHeader,
    },
    data() {
      return{
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: '',
          status: '',
          sort: {
            sort: '',
            order: ''
          }
        },
        isLoading: false,
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200]
        },
        selectedIds: []
      }
    },
    computed: {
      ...mapState('brandAdmin', {
        brandsData: state => state.list.data,
        brandsResponse: state => state.list.response,
        brandsStatus: state => state.list.status,
      }),
      listFilters() {
        return this.$store.state.brandAdmin.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_file'), sort: { sorteable: true, order: "" }, column: "filename" },
          { title: this.$t('key_theader_file_type'), sort: { sorteable: true, order: "" }, column: "procesoId" },
          { title: this.$t('key_theader_entity_type'), sort: { sorteable: true, order: "" }, column: "entity_type" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_created_at'), sort: { sorteable: true, order: "" }, column: "created_at" },
        ]
      }
    },
    watch: {
      brandsResponse() {
        if(this.brandsData) {
          this.pagination.total = this.brandsData.total;
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.setUpFilters();
      if (Object.keys(this.$route.query).length > 0) {
        this.filters.status = this.$route.query.status;
      }
      this.getBrandsList();
    },
    methods: {
      ...mapActions('brandAdmin', [
                                    'getBrands'
                                  ]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      async getBrandsList() {
        if (this.brandsStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          await this.getBrands({filters: this.filters, pagination: this.pagination});
          
          if (this.brandsStatus === 'success' && this.brandsResponse.status === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.brandsStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      
      
      addBrand() {
        this.$router.push({ path: "/CustomerService/Customers/NewBrand/" });
      },
      
      
      
      
      
      
      
      changedSelection(id) {
        if (this.selectedIds.includes(id)) {
          this.selectedIds = this.selectedIds.filter(itemId => itemId !== id);
        } else {
          this.selectedIds.push(id);
        }
      },
      clearSelection() {
        this.selectedIds = [];
      },
      async clearAllFilters() {
        this.filters.status = '';
        this.filters.search = '';
        this.pagination.currentPage = 1;
        await this.getBrandsList();

      },
      async searchChange(value) {
        this.pagination.currentPage = 1;
        this.filters.search = value;
        await this.getBrandsList();
      },
      async reloadPage() {
        await this.getBrandsList();
      },
      /* async brandStatusFilterChange(val) {
        this.pagination.currentPage = 1;
        this.filters.status = val;
        await this.getImportsList();
      }, */
      async onChangeHeader(val){
        this.filters.sort = {
          sort: val.column,
          order: val.order == "asc" ? "ascending" : "descending",
        }
        await this.getBrandsList(); 
      },
      async paginationPageChange(page) {
        this.pagination.currentPage = page;
        await this.getBrandsList(); 
      },
      async paginationRowChange(rows) {
        this.pagination.rows = rows;
        await this.getBrandsList(); 
      },
      
      
      
      /* openWarehouse(name) {
        this.$router.push({ path: "/Stock/", state: { warehouse: name }});
      } */
    }
  };

</script>

<!-- <style scoped>

  .columns {
    max-width: 150px;
  }

</style> -->










<!-- <script>

  import GenericTable from "./../../../../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../../../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../../../../picko_components/generic_components/Searchbox.vue";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./../components/Filter.vue";

  export default {
    name: "ImportsList",
    components: {
      SoftSnackbar,
      Filter,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        currentFileName: '',
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          }
        },
      };
    },
    computed: {
      batchLoads() {
        return this.$store.state.batchLoads.list.data;
      },
      batchDownload() {
        return this.$store.state.batchLoads.resource.data;
      },
      batchLoadsExcel() {
        return this.$store.state.order.ordersExcel.data;
      },
      listFilters() {
        return this.$store.state.batchLoads.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_file'), sort: { sorteable: true, order: "" }, column: "filename" },
          { title: this.$t('key_theader_file_type'), sort: { sorteable: true, order: "" }, column: "procesoId" },
          { title: this.$t('key_theader_entity_type'), sort: { sorteable: true, order: "" }, column: "entity_type" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_createdat'), sort: { sorteable: true, order: "" }, column: "created_at" }
        ];
      },
      title() {
        return this.$t('key_batchUploadList_table_title');
      },
      description() {
        return this.$t('key_batchUploadList_table_description');
      }
    },
    watch: {
      batchLoads() {
        if(this.batchLoads){
          this.pagination.total= this.batchLoads.data.total;
          this.isLoading = false;
        }
      },
      batchDownload() {
        if (this.$store.state.order.ordersExcel.error) {
          const error = this.$store.state.order.ordersExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else {
          this.$viewUtils.hideSpinner()
          this.downloadExcel(this.batchDownload);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getBatchLoads();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      getBatchLoads() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("batchLoads/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getBatchLoads();
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getBatchLoads(); 
      },
      importSuccess(){
        this.notificationInfo = {
          title: this.$t('key_mheader_batchloads_sent'),
          message: this.$t('key_mmessage_batchloads_sent'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getBatchLoads();
        }, 3000)
      },
      importFailure(status){
        this.notificationInfo = {
          title: this.$t('key_mheader_batchloads_error'),
          message: status.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification()
      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
          self.showNotification = false
        }, 2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getBatchLoads(); 
      },
      onFilterChange(value){
        this.$router.replace({'query': {}})
        this.pagination.currentPage = 1;
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getBatchLoads(); 
      },
      OnDownloadBatch(batch){
        this.currentFileName = batch['filename'] ?? ''
        this.$store.commit("batchLoads/downloadResource", {
          'processId': batch['procesoId'],
          'filename': batch['filename']
        });
        this.$viewUtils.showSpinner(this.batchLoads)
      },
      onDownloadExcel(){
        this.$store.commit("order/ordersExcel", this.filters);
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        link.setAttribute('download', this.currentFileName);
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
        this.currentFileName = ""
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getBatchLoads(); 
      },
    },
  };

</script> -->

<style scoped>

  .units ul {
    list-style-type: none;
    margin-bottom: 0rem;
  }

</style>